/* ==========================================================================
   prinsert-eco-box.js   -- Fassung 8
   --------------------------------------------------------------------------
   Zum Pruefen, welche Fassung im Browser laeuft, in der Konsole eingeben:
       window.__prinsertEcoBoxVersion

   Setzt das Kontrollkaestchen "Wiederverwendeten Versandkarton verwenden"
   in den Warenkorb -- auf der Seite /cart und in der Schublade.

   ==========================================================================
   ZURUECKGEBAUT: DER BEWERTUNGSBLOCK

   Bis Fassung 7 hat dieses Skript den Judge.me-Block aus dem scrollenden
   Bereich in den Fussbereich gezogen, damit er immer sichtbar bleibt.
   Vier Anlaeufe, keiner hat gehalten:

     1. position: sticky mit max-height   Karten verschwanden -- das
                                          Karussell misst sich beim Aufbau
                                          selbst und vertraegt keine
                                          Hoehenvorgabe von aussen
     2. sticky ohne max-height            Block nahm die ganze Schublade
                                          ein und verdeckte die Produkte
     3. Verschieben in den Fussbereich    Bewertungen nicht mehr anklickbar
     4. eigener Container im Fussbereich  ebenso

   Der Block laeuft jetzt wieder dort, wo Judge.me ihn hinsetzt: im
   scrollenden Bereich hinter den Produkten. Er scrollt damit mit -- das
   ist der Preis dafuer, dass er vollstaendig bedienbar bleibt.

   WER ES ERNEUT VERSUCHT: Das Problem ist nicht die Positionierung,
   sondern dass der Block von einer fremden App aufgebaut und verwaltet
   wird. Sie misst, bindet Ereignisse und baut bei Bedarf neu auf. Jeder
   Eingriff von aussen -- verschieben, beschneiden, in der Groesse
   festlegen -- kollidiert damit an einer anderen Stelle. Der aussichts-
   reichere Weg waere die Widget-Einstellung bei Judge.me selbst oder ein
   eigener, schlanker Vertrauensanker (Sterne plus Anzahl als eigenes
   Markup), der nichts mit dem App-Block zu tun hat.

   ==========================================================================
   DAS KAESTCHEN -- FESTGELEGTE PUNKTE

   WARUM NICHT IM CHECKOUT: Felder auf der Checkout-Seite brauchen eine
   Checkout-UI-Erweiterung, und die ist dem Plus-Tarif vorbehalten. Der
   Warenkorb ist auf dem Basic-Tarif die letzte Station.

   WIE DER WERT IN DIE BESTELLUNG KOMMT: Als Warenkorb-Attribut ueber
   /cart/update.js. Ein leerer String loescht das Attribut wieder --
   deshalb wird beim Abwaehlen '' geschrieben und nicht 'Nein'. So stehen
   in den Bestellungen nur die Faelle mit ausdruecklicher Zustimmung.

   BEWUSST OHNE name-ATTRIBUT: Das Kaestchen liegt auf /cart im
   Warenkorb-Formular; ein benanntes Feld wuerde beim Absenden mitgehen
   und mit dem Attribut kollidieren.

   DER HINWEIS KLAPPT IM FLUSS AUF, NICHT ALS SCHWEBENDE BLASE. Drei
   Anlaeufe mit position: absolute beziehungsweise fixed sind an der
   Schublade gescheitert: Sie beschneidet ihren Inhalt (overflow).
   BITTE NICHT WIEDER IN EIN POPUP VERWANDELN.

   DAS i-SYMBOL LIEGT AUSSERHALB DES LABELS. Innerhalb waere jeder Klick
   darauf zugleich ein Klick auf die Beschriftung und wuerde das Kaestchen
   umschalten.

   DER KNOPF IST type="button": Ein <button> ohne Typ ist innerhalb eines
   Formulars ein Absende-Knopf.
   ========================================================================== */

(function () {
  if (window.__prinsertEcoBox) return;
  window.__prinsertEcoBox = true;
  window.__prinsertEcoBoxVersion = 8;

  var ATTR = 'Wiederverwendeter Karton';
  var YES = 'Ja';
  var LABEL = 'Wiederverwendeten Versandkarton verwenden';
  var INFO =
    'Wenn m\u00f6glich, verwenden wir f\u00fcr deine Bestellung einen bereits ' +
    'verwendeten, noch stabilen Versandkarton. Damit geben wir Verpackungen ' +
    'ein zweites Leben, vermeiden Abfall und tragen dazu bei, wertvolle ' +
    'Ressourcen zu schonen. Der Karton kann leichte Gebrauchsspuren aufweisen.';

  var state = false;
  var scheduled = null;

  function buildBlock() {
    var wrap = document.createElement('div');
    wrap.className = 'prinsert-eco';
    wrap.setAttribute('data-prinsert-eco', '');

    /* Zeile: Kaestchen, Text, Symbol -- drei Spalten, die nicht umbrechen. */
    var row = document.createElement('div');
    row.className = 'prinsert-eco__row';

    var label = document.createElement('label');
    label.className = 'prinsert-eco__label';

    var input = document.createElement('input');
    input.type = 'checkbox';
    input.className = 'prinsert-eco__checkbox';
    input.checked = state;
    input.addEventListener('change', function () {
      save(input.checked);
    });
    label.appendChild(input);

    var text = document.createElement('span');
    text.className = 'prinsert-eco__text';
    text.textContent = LABEL;
    label.appendChild(text);

    row.appendChild(label);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'prinsert-eco__info-btn';
    btn.setAttribute('aria-label', 'Mehr Informationen zum wiederverwendeten Versandkarton');
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'i';
    row.appendChild(btn);

    wrap.appendChild(row);

    var hint = document.createElement('div');
    hint.className = 'prinsert-eco__hint';
    hint.textContent = INFO;
    hint.hidden = true;
    wrap.appendChild(hint);

    btn.addEventListener('click', function (event) {
      event.preventDefault();
      hint.hidden = !hint.hidden;
      btn.setAttribute('aria-expanded', hint.hidden ? 'false' : 'true');
      btn.classList.toggle('is-open', !hint.hidden);
    });

    return wrap;
  }

  /* ANKERPUNKTE -- die Notiz sieht auf /cart und in der Schublade
     unterschiedlich aus:

       /cart      <cart-note class="cart__note field"> ... </cart-note>
       Schublade  <details> <summary>Spezielle Bestellanweisungen</summary>
                    <cart-note> ... </cart-note>
                  </details>

     Deshalb wird ZUERST auf ein umgebendes <details> geprueft. Ohne das
     landete das Kaestchen INNERHALB des Aufklappbereichs: zugeklappt gar
     nicht sichtbar, aufgeklappt hinter dem Textfeld. */
  function anchors() {
    var found = [];

    document.querySelectorAll('textarea[name="note"]').forEach(function (note) {
      var host =
        note.closest('details') ||
        note.closest('.cart__note') ||
        note.closest('cart-note') ||
        note.parentElement;
      if (host) found.push({ host: host, position: 'afterend' });
    });

    if (!found.length) {
      document.querySelectorAll('[name="checkout"]').forEach(function (btn) {
        var host = btn.closest('.cart__ctas') || btn.parentElement;
        if (host) found.push({ host: host, position: 'beforebegin' });
      });
    }

    return found;
  }

  function alreadyThere(host, position) {
    var sibling = position === 'afterend' ? host.nextElementSibling : host.previousElementSibling;
    return !!(sibling && sibling.hasAttribute && sibling.hasAttribute('data-prinsert-eco'));
  }

  function sync() {
    document.querySelectorAll('.prinsert-eco__checkbox').forEach(function (box) {
      if (box.checked !== state) box.checked = state;
    });
  }

  function render() {
    anchors().forEach(function (entry) {
      if (alreadyThere(entry.host, entry.position)) return;
      entry.host.insertAdjacentElement(entry.position, buildBlock());
    });
    sync();
  }

  function save(value) {
    state = value;
    sync();

    var body = { attributes: {} };
    body.attributes[ATTR] = value ? YES : '';

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).catch(function () {
      /* Netzwerkfehler: Die Anzeige bleibt stehen, damit der Kunde nicht
         vor einem zurueckspringenden Haken sitzt. */
    });
  }

  function load() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        state = !!(cart && cart.attributes && cart.attributes[ATTR]);
        sync();
      })
      .catch(function () {});
  }

  function start() {
    render();
    load();

    /* Dawn ersetzt den Inhalt der Schublade nach jeder Warenkorb-Aenderung
       komplett -- das Kaestchen muss danach erneut eingesetzt werden. */
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = window.requestAnimationFrame(function () {
        scheduled = null;
        render();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
